import { render } from "./NavbarUser.vue?vue&type=template&id=e699fbc2&scoped=true"
import script from "./NavbarUser.vue?vue&type=script&lang=js"
export * from "./NavbarUser.vue?vue&type=script&lang=js"

import "./NavbarUser.vue?vue&type=style&index=0&id=e699fbc2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e699fbc2"]])

export default __exports__